/*
 * @Author: huangzq
 * @Date: 2020-05-30 13:58:37
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-05-30 14:18:59
 * @Desc: 获取用户信息接口失败，对应的code、message
*/
export default {
  500110: '第三方平台token失效，联系管理员处理',
  500111: '未绑定开放平台账户，联系管理员处理',
  500112: '未找到公司授权的公众号信息，联系管理员处理',
  500113: '未找到公司的复用授权关系，联系管理员处理',
  500114: 'jssdk签名失败，appId不正确',
  500115: 'jssdk签名失败，公众号token失效',
}
